export default __webpack_public_path__ + "static/imgannonce1-2bc4cf738f3823506f06ad6272f4d441.jpg";